export default class Coupon {
  static init() {
    if (
      !TMON.oApp.htStorage.d2cInfo ||
      !TMON.oApp.htStorage.d2cInfo.data ||
      !Object.keys(TMON.oApp.htStorage.d2cInfo.data).length ||
      !TMON.oApp.htStorage.d2cInfo.data.chnlVw === 'N' ||
      TMON.oApp.htStorage.d2cInfo.data.chnlCouponExistYn === 'N'
    ) {
      document.querySelector('.d2c_coupon').remove();
      return;
    }
    const parent = document.querySelector('.d2c_coupon');
    const childHtml = new Coupon();
    parent.innerHTML = childHtml.render();
  }

  render() {
    const {
      data: { chnlTitle, chnlEn },
    } = TMON.oApp.htStorage.d2cInfo;
    return `
      <p class="d2c_coupon_text">
        <span class="text_ellipsis">${chnlTitle}</span>에서<br>준비한 <span class="text_point">특별한 할인 혜택!</span>
      </p>
      <span class="d2c_coupon_image" aria-label="brand coupon"></span>
      <a href="${this.randingBrandHome(
        chnlEn
      )}" class="d2c_coupon_button" tl:area='DCCNH1'>브랜드 홈에서 쿠폰 받기</a>
    `;
  }

  randingBrandHome(chnlEn) {
    return TMON.view_mode === 'app'
      ? `javascript:TMON.app.callApp('webview', 'goD2CChannelHome', '${chnlEn}')`
      : `${TMON.htLocal.htURL.home}/m/brand/${chnlEn}`;
  }
}
